module.exports = __webpack_public_path__ + "media/docx_img_2.ca22bf62.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/flags/docx_img_2.png
// module id = 676
// module chunks = 2